export default __webpack_public_path__ + "static/media/email_failure.d927be63.svg";